import Search from "./svg/Search";
import Menu from "./svg/Menu";
import Close from "./svg/Close";
import VK from "./svg/VK";
import Youtube from "./svg/Youtube";
import LogoText from "./svg/LogoText";
import LogoFooterText from "./svg/LogoFooterText";
import LogoBiblio from "./svg/LogoBiblio";
import LogoBiblioText from "./svg/LogoBiblioText";
import Loading from "./svg/Loading";
import LogoDepMos from "./svg/LogoDepMos";
import Edit from "./svg/Edit";
import ArrowLeft from "./svg/ArrowLeft";
import Pencil from "./svg/Pencil";
import Share from "./svg/Share";
import Attach from "./svg/Attach";

export default {
  search: Search,
  menu: Menu,
  close: Close,
  vk: VK,
  youtube: Youtube,
  logoText: LogoText,
  logoFooterText: LogoFooterText,
  logoBiblio: LogoBiblio,
  logoBiblioText: LogoBiblioText,
  logoDepMos: LogoDepMos,
  loading: Loading,
  edit: Edit,
  arrowLeft: ArrowLeft,
  pencil: Pencil,
  share: Share,
  attach: Attach,
};



// WEBPACK FOOTER //
// ./src/nekrasovka-ui/Icons/icons.js